<template>
  <div class="modal-container-wrapper">
    <BaseModal
      v-for="modal in modalStore.modals"
      :key="modal.id"
      :visible="!modal.isClosing"
      :title="modal.title"
      :content="modal.content"
      :component="modal.component"
      :component-props="modal.props"
      :show-close-button="modal.showCloseButton"
      :persistent="modal.persistent"
      @close="modalStore.closeModal(modal.id)"
    />
  </div>
</template>

<script setup lang="ts">
import { useModalStore } from '@/stores/useModal'
import BaseModal from './BaseModal.vue'

const modalStore = useModalStore()
</script>


